import { validateUserLocalPart, gettingDomainQuota } from '../API/APICalls';
// Reused some functions.

export const decideBatchSize = (totalEntries) => {
    const thresholds = [200, 150, 100, 70, 60, 50, 30, 20, 0];
    const batchSizes = [50, 40, 30, 25, 20, 12, 9, 7, 5];
    return batchSizes[thresholds.findIndex(threshold => totalEntries >= threshold)];
};

export const createBatches = (data, batchSize) => {
    return Array.from({ length: Math.ceil(data.length / batchSize) }, (_, i) =>
        data.slice(i * batchSize, i * batchSize + batchSize)
    );
};


// Function to validate local part
export const validateLocalPart = async (id, domainId, localPart) => {
    try {
        const response = await validateUserLocalPart(id, domainId, localPart);
        if (response?.data) {
            throw new Error(`Local part ${localPart} already exists.`);
        }
    } catch (error) {
        throw error;
    };
};

// Function to validate quota
export const validateQuota = async (id, domainId, allocatedSpace) => {
    try {
        const response = await gettingDomainQuota(id, domainId);
        if (!response?.data) {
            throw new Error('There is no quota available space to create new user.');
        }
        if (response?.data < allocatedSpace) {
            throw new Error(`Allocated space is ${allocatedSpace} more than available space ${response.data}.`);
        }
    } catch (error) {
        throw error;
    };
};

//id, values.domain_id, values.allocated_space, old_allocated_space, values.used_space
export const validateQuotaForEdit = async (id, domainId, allocatedSpace, oldAllocatedSpace, usedSpace) => {
    const response = await gettingDomainQuota(id, domainId);
    if (!response?.data && allocatedSpace > oldAllocatedSpace){
        throw new Error('There is no quota available space.');
    }
    const avaliableSpace = response.data;
    const changedSpace = allocatedSpace - oldAllocatedSpace;
    if (allocatedSpace < usedSpace){
        throw  new Error(`Allocated space ${allocatedSpace} GB is lesser than the used space ${usedSpace} GB`)
    }
    if (allocatedSpace > oldAllocatedSpace && changedSpace > avaliableSpace){
        throw new Error(`Changed allocated space ${changedSpace} GB is more than available space ${avaliableSpace} GB`);
    }
};

// Function to validate quota
export const validateQuotaForCreateBulk = async (id, domainId, totalAllocatedSpace, domainName) => {
    try {
        const response = await gettingDomainQuota(id, domainId);
        if ( !response?.data){
            throw new Error('There is no quota available space to create new user.');
        }
        if (response?.data < totalAllocatedSpace) {
            throw new Error(`Total allocated space is ${totalAllocatedSpace} for domain ${domainName} more than available space ${response.data}.`);
        }
    } catch (error) {
        throw error;
    };
};